import { ApiRoutes } from "../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../base";
import { DashboardRequestBody, DashboardResponse } from "./types";

export class DashboardAPI extends BaseAPI<
    DashboardRequestBody,
    DashboardResponse
> {
    protected route = ApiRoutes.home;
    protected method = RequestMethod.GET;
}
